export const NewsletterTranslationLabelKeys = (prefix: string) =>
  ({
    Checkbox: `${prefix}.checkbox.newsletter.label`,
    OptIn: `${prefix}.radio.newsletter.option.opt-in.label`,
    OptOut: `${prefix}.radio.newsletter.option.opt-out.label`
  }) as const;
